const awsmobile = {
  Auth: {
    region: process.env.VUE_APP_AWS_REGION,
    userPoolId: process.env.VUE_APP_AWS_USER_POOL,
    userPoolWebClientId: process.env.VUE_APP_AWS_USER_CLIENT_ID,
  },
};

export default awsmobile;
